import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Signinglocations } from 'src/app/models/signinglocations';
import { Signingreasons } from 'src/app/models/signingreasons';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { ToastService } from 'src/app/services/toast.service';
import { SettingsService } from '../../settings.service';
import { PlatformSettings } from 'src/app/constants/settings.enum';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { Subscription } from 'rxjs';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { OrganisationSettingsApiClient } from 'src/app/services/organisation-settings.apiclient';
import { LoggingService } from 'src/app/services/logging.service';

@Component({
  templateUrl: './signing.page.html'
})
export class SigningPage implements OnDestroy {
  locationReasonSettings: any = [];
  signingMethodSettings: any = [];
  locations: Signinglocations[] = [];
  reasons: Signingreasons[] = [];
  translations = <any>{};
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;

  constructor(private settingsService: SettingsService, 
    private organisationApiClient: OrganisationApiClient, 
    private toastService: ToastService, 
    private translateService: TranslateService, 
    private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient,
    private organisationSettingsApiClient: OrganisationSettingsApiClient, private loggingService: LoggingService) {
      this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
        if (organisationId === this.selectedOrganisationId) return;
        this.selectedOrganisationId = organisationId;
        // setup specialised breadcrumb
        this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Application(this.selectedOrganisationId), BreadCrumbOptions.Application_Signing(this.selectedOrganisationId));

        this.getSigningSettings();
        this.getSigningLocations();
        this.getSigningReasons();
      });

      this.getTranslations();
      translateService.onLangChange.subscribe(() => {
        this.getTranslations();
      })
    }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  private async getSigningSettings() {
    let signingSettings: PlatformSettings[] = [PlatformSettings.ShowLocation, PlatformSettings.ShowReason, PlatformSettings.UseInternalStamp, PlatformSettings.UseExternalStamp, PlatformSettings.UseInternalDraw, PlatformSettings.UseExternalDraw, PlatformSettings.UseInternalPicture, PlatformSettings.UseExternalPicture];
    
    await this.organisationApiClient.getOrganisationSettingsByFilter(this.selectedOrganisationId, signingSettings).subscribe({
      next: (settings: any) => {
        let locationReasonSettingsReturnedObject: any = {};
        let signingMethodSettingsReturnedObject: any = {};
        settings.forEach((setting: any) => {
          locationReasonSettingsReturnedObject[setting.key] = setting.value;
          signingMethodSettingsReturnedObject[setting.key] = setting.value;
        });

        if (locationReasonSettingsReturnedObject.ShowLocation == undefined || locationReasonSettingsReturnedObject.ShowLocation == "" || locationReasonSettingsReturnedObject.ShowLocation == "false") locationReasonSettingsReturnedObject.ShowLocation = false;
        else locationReasonSettingsReturnedObject.ShowLocation = true;
        if (locationReasonSettingsReturnedObject.ShowReason == undefined || locationReasonSettingsReturnedObject.ShowReason == "" || locationReasonSettingsReturnedObject.ShowReason == "false") locationReasonSettingsReturnedObject.ShowReason = false;
        else locationReasonSettingsReturnedObject.ShowReason = true;

        this.locationReasonSettings = locationReasonSettingsReturnedObject;
        
        if (signingMethodSettingsReturnedObject.UseInternalStamp == "false") signingMethodSettingsReturnedObject.UseInternalStamp = false;
        else signingMethodSettingsReturnedObject.UseInternalStamp = true;
        if (signingMethodSettingsReturnedObject.UseExternalStamp == "false") signingMethodSettingsReturnedObject.UseExternalStamp = false;
        else signingMethodSettingsReturnedObject.UseExternalStamp = true;
        if (signingMethodSettingsReturnedObject.UseInternalDraw == "false") signingMethodSettingsReturnedObject.UseInternalDraw = false;
        else signingMethodSettingsReturnedObject.UseInternalDraw = true;
        if (signingMethodSettingsReturnedObject.UseExternalDraw == "true") signingMethodSettingsReturnedObject.UseExternalDraw = true;
        else signingMethodSettingsReturnedObject.UseExternalDraw = false;
        if (signingMethodSettingsReturnedObject.UseInternalPicture == "false") signingMethodSettingsReturnedObject.UseInternalPicture = false;
        else signingMethodSettingsReturnedObject.UseInternalPicture = true;
        if (signingMethodSettingsReturnedObject.UseExternalPicture == "true") signingMethodSettingsReturnedObject.UseExternalPicture = true;
        else signingMethodSettingsReturnedObject.UseExternalPicture = false;

        this.signingMethodSettings = signingMethodSettingsReturnedObject;
      }
    });
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.GetLocationError',
      'Toasts.AddLocationError',
      'Toasts.ChangeOrderLocationError',
      'Toasts.RemoveLocationError',
      'Toasts.GetReasonError',
      'Toasts.AddReasonError',
      'Toasts.ChangeOrderReasonError',
      'Toasts.RemoveReasonError',
      'Toasts.Error',
      'Toasts.Saved',
      'Toasts.ChangesSaved'
    ]).subscribe(translation => {
      this.translations.toastsGetLocationError = translation['Toasts.GetLocationError'];
      this.translations.toastsAddLocationError = translation['Toasts.AddLocationError'];
      this.translations.toastsChangeOrderLocationError = translation['Toasts.ChangeOrderLocationError'];
      this.translations.toastsRemoveLocationError = translation['Toasts.RemoveLocationError'];
      this.translations.toastsAddReasonError = translation['Toasts.AddReasonError'];
      this.translations.toastsGetReasonError = translation['Toasts.GetReasonError'];
      this.translations.toastsChangeOrderReasonError = translation['Toasts.ChangeOrderReasonError'];
      this.translations.toastsRemoveReasonError = translation['Toasts.RemoveReasonError'];
      this.translations.error = translation['Toasts.Error'];
      this.translations.toastSaved = translation['Toasts.Saved'];
      this.translations.toastChangedSaved = translation['Toasts.ChangesSaved'];
    });
  }

  private getSigningLocations() {
    this.organisationApiClient.getSigningLocations(this.selectedOrganisationId).subscribe({
      next: (data: any) => {
        this.locations = data;
      },
      error: () => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsGetLocationError + "");
      }
    });
  }

  private getSigningReasons() {
    this.organisationApiClient.getSigningReasons(this.selectedOrganisationId).subscribe({
      next: (data: any) => {
        this.reasons = data;
      },
      error: () => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsGetReasonError + "");
      }
    });
  }

  async addLocation(location: Signinglocations) {
    this.organisationApiClient.postSigningLocations(this.selectedOrganisationId, location.location).subscribe({
      next: (data: Signinglocations) => {
        this.locations.push(data);
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      },
      error: () => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsAddLocationError + "");
      }
    });
  }

  async addReason(reason: Signingreasons) {
    this.organisationApiClient.postSigningReason(this.selectedOrganisationId, reason.reason).subscribe({
      next: (data: Signingreasons) => {
        this.reasons.push(data);
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      },
      error: () => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsAddReasonError + "");
      }
    });
  }

  async removeReason(reason: number) {
    this.organisationApiClient.deleteSigningReason(this.selectedOrganisationId, reason).subscribe({
      next: () => {
        let reasonIndex = this.reasons.findIndex(s => s.id === reason);
        this.reasons.splice(reasonIndex, 1);
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      },
      error: () => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsRemoveReasonError + "");
      }
    });
  }

  async removeLocation(location: number) {
    this.organisationApiClient.deleteSigningLocation(this.selectedOrganisationId, location).subscribe({
      next: () => {
        let locationIndex = this.locations.findIndex(s => s.id === location);
        this.locations.splice(locationIndex, 1);
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      },
      error: () => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsRemoveLocationError + "");
      }
    });
  }

  updateValueFromSwitch(event: any) {
    this.settingsService.updateSettings([{key:event.key, value:String(event.checked) }], this.selectedOrganisationId);
  }

  async reasonChangeOrder(event: any) {
    let orderReasons: Signingreasons[] = this.reasons;
    moveItemInArray(orderReasons, event.previousIndex, event.currentIndex);
    await this.changeOrderReasons(orderReasons);
  }

  private async changeOrderReasons(orderReasons: Signingreasons[]) {
    let newReasonsOrder: Signingreasons[] = [];
    for (let i = 0; i < orderReasons.length; i++) {
      if (orderReasons[i]) {
        newReasonsOrder.push(orderReasons[i]);
      }
    }
    (await this.organisationApiClient.changeReasonOrder(this.selectedOrganisationId, newReasonsOrder)).subscribe({
      error: () => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsChangeOrderReasonError + "");
      },
      next: () => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      }
    });
  }

  async locationChangeOrder(event: any) {
    let orderLocations: Signinglocations[] = this.locations;
    moveItemInArray(orderLocations, event.previousIndex, event.currentIndex);
    await this.changeOrderLocations(orderLocations);
  }

  private async changeOrderLocations(orderLocations: Signinglocations[]) {
    let newLocationOrder: Signinglocations[] = [];
    for (let i = 0; i < orderLocations.length; i++) {
      if (orderLocations[i]) {
        newLocationOrder.push(orderLocations[i]);
      }
    }
    (await this.organisationApiClient.changeLocationOrder(this.selectedOrganisationId, newLocationOrder)).subscribe({
      error: () => {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsChangeOrderLocationError + "");
      },
      next: () => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      }
    });
  }
}
